import { generatePermissionForEntity } from '../util';
export var StoreMenuManagementPermissions;
(function (StoreMenuManagementPermissions) {
    StoreMenuManagementPermissions["API_EDIT_AVAILABILITY"] = "API_EDIT_AVAILABILITY";
    StoreMenuManagementPermissions["WEB_EDIT_AVAILABILITY"] = "WEB_EDIT_AVAILABILITY";
})(StoreMenuManagementPermissions || (StoreMenuManagementPermissions = {}));
export const STORE_MENU_MANAGEMENT_PERMISSIONS = generatePermissionForEntity('STORE_MENU_MANAGEMENT', StoreMenuManagementPermissions);
//# sourceMappingURL=store-menu-management.js.map